import { __awaiter } from 'tslib';

const ENDPOINT = 'GETsongsForPitching';
function getSongsForPitching(gateway, params, customURL = null, customHeaders = null, isKoussa = false) {
    return __awaiter(this, void 0, void 0, function* () {
        return gateway.get(getSongsForPitching.endpoint, params, customURL, customHeaders, isKoussa);
    });
}
getSongsForPitching.endpoint = ENDPOINT;

export { getSongsForPitching as default };
//# sourceMappingURL=getSongsForPitching.js.map
